import { useEffect, useState } from "react";
import type { ICellRendererParams } from "ag-grid-community";

interface CheckboxParams extends ICellRendererParams {
  label?: string;
  isVisible?: (data: any, params: any) => boolean;
  onChange?: (params: any) => void;
}

export default function AggridCheckbox(params: CheckboxParams) {
  const [isChecked, setIsChecked] = useState<boolean>(!!params.value);

  useEffect(() => {
    setIsChecked(!!params.value);
  }, [params.value]);

  function isVisible() {
    if (!params.isVisible) return false;
    return params.isVisible(params.node.data, params);
  }

  function handleChange(checked: boolean) {
    setIsChecked(checked);

    const field = params.colDef?.field;
    if (!field) return;

    params.node.data[field] = checked;

    if (params.onChange) {
      params.onChange(params);
    }
  }

  if (!isVisible()) return null;

  return (
    <div className="ag-cell-wrapper ag-checkbox-cell">
      <label>
        <div className="ag-labeled ag-label-align-right ag-checkbox ag-input-field">
          <div
            className={`btn_sub_wrap ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper${isChecked ? " ag-checked" : ""}`}
          />
          <div>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => handleChange(e.target.checked)}
              className="ag-input-field-input ag-checkbox-input"
              style={{ display: "none" }}
            />
            &nbsp;{params.label}
          </div>
        </div>
      </label>
    </div>
  );
}
